/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';

export interface RotateArrowIconProps {
  color?: string;
  size?: number;
}
/*
 * Defines the Design Language System (DLS) Rotate Arrow Icon component.
 */
export const RotateArrowIcon = ({size = 24, color = dlsColor('caRed')}: RotateArrowIconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 26 23" fill={'none'}>
      <path xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd" d="M9.69555 5.12823C9.64742 4.57805 10.0544 4.09301 10.6046 4.04488L16.1974 3.55557C16.7476 3.50743 17.2326 3.91442 17.2808 4.46461L17.7701 10.0574C17.8182 10.6076 17.4112 11.0927 16.861 11.1408C16.3109 11.1889 15.8258 10.7819 15.7777 10.2318L15.3755 5.63511L10.7789 6.03727C10.2287 6.0854 9.74369 5.67841 9.69555 5.12823Z" fill={color}/>
      <path xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd" d="M7.69074 14.8713C8.45853 12.5939 10.0078 10.4771 11.4354 8.77574L15.5183 3.91002C15.8733 3.48694 16.504 3.43176 16.9271 3.78676C17.3502 4.14176 17.4053 4.77252 17.0503 5.19559L12.9675 10.0613C11.5765 11.7191 10.2297 13.6007 9.58594 15.5102C8.96456 17.3533 9.01138 19.1597 10.2901 20.8772L11.2332 21.8484C11.6179 22.2446 11.6086 22.8777 11.2124 23.2625C10.8162 23.6472 10.1831 23.6379 9.79834 23.2417L8.81125 22.2252C8.78293 22.1961 8.75642 22.1652 8.73186 22.1328C6.92576 19.7512 6.90625 17.1982 7.69074 14.8713Z" fill={color}/>
    </svg>
  );
};
